import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import MessagesContext from '../../../contexts/messagesContext';
import useCheckMobileScreen from '../../../hooks/useWidth';

import { MainDialog } from '../../UI';

import LabDetailForm from './LabDetailForm';
import WithPatientFileHeader from '../../PatientFileHeader/WithPatientFileHeader';

function LaboratoryDetailForm({ history, match }) {
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);

    const { id: patient_id, group_id, result_id } = match?.params;
    const isNewLabResult = useMemo(() => `${group_id}`.includes('new'), [group_id]);

    return (
        <>
            {isMobile ? (
                <LabDetailForm
                    isNewLabResult={isNewLabResult}
                    patient_id={patient_id}
                    group_id={group_id}
                    result_id={result_id}
                    history={history}
                />
            ) : (
                <MainDialog
                    open={true}
                    title={isNewLabResult ? messages.newLabData : messages.editLabData}
                    goBack={history.goBack}
                >
                    <LabDetailForm
                        isNewLabResult={isNewLabResult}
                        patient_id={patient_id}
                        group_id={group_id}
                        result_id={result_id}
                        history={history}
                    />
                </MainDialog>
            )}
            {/* </Dialog> */}
        </>
    );
}
LaboratoryDetailForm.propTypes = {
    history: PropTypes.any,
    match: PropTypes.any
};

export default WithPatientFileHeader(
    LaboratoryDetailForm,
    ['sidebar', 'newLaboratory'],
    false,
    'white'
);
